import clientInherit from './list'
export default clientInherit